import type { TravelReviewStats } from "@busbud/core-types/dist/lib/grand-central/api/travel-reviews";
import type { Amenity } from "@busbud/int-schemas/udm";

import type { DisplayableRatingElement } from "@app/modules/shared/featured-profiles";

export type OperatorRatingsCategory = Extract<
  DisplayableRatingElement,
  "staff_rating" | "timeliness_rating" | "cleanliness_rating" | "wifi_rating"
>;

export interface TripOperatorRatingCategory {
  id: OperatorRatingsCategory;
  rating: number | null;
}

export const getTripOperatorCategoryRatings = (
  display_operator_rating: TravelReviewStats,
  amenities: Partial<Record<Amenity, boolean>>
) => {
  const rating_categories: TripOperatorRatingCategory[] = [
    {
      id: "staff_rating",
      rating: display_operator_rating.staff_rating
    },
    {
      id: "timeliness_rating",
      rating: display_operator_rating.timeliness_rating
    },
    {
      id: "cleanliness_rating",
      rating: display_operator_rating.cleanliness_rating
    }
  ];

  if (amenities.wifi) {
    rating_categories.push({
      id: "wifi_rating",
      rating: display_operator_rating.wifi_rating
    });
  }
  return rating_categories;
};
